import React from 'react';
import {ETooltip} from 'webapp-lib/Components';

import {MinimalContact} from '@lexian/api/contacts-api';
import {Company, Person, Pseudonym} from '_/assets/images';
import i18n from '_/i18n';

export const getContactTypeIcon = (
  type: MinimalContact['contactType'] | undefined
): React.ReactElement => {
  switch (type) {
    case 'NATURAL_PERSON':
      return (
        <ETooltip title={i18n.t('contacts:icons.naturalPerson')}>
          <Person />
        </ETooltip>
      );
    case 'LEGAL_ENTITY':
      return (
        <ETooltip title={i18n.t('contacts:icons.legalEntity')}>
          <Company />
        </ETooltip>
      );
    default:
      return (
        <ETooltip title={i18n.t('contacts:icons.pseudonym')}>
          <Pseudonym />
        </ETooltip>
      );
  }
};
